import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React from "react";
import bgImage from "assets/images/terms.png";
import { useTranslation } from "react-i18next";
/* eslint-disable react/prop-types */
const Termsofuse = () => {
  const [t] = useTranslation("common");
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "left",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="left" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              <h2>{t("termsofuse.header")}</h2>
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="left"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <div>
                {t("termsofuse.text")}
                <h3>{t("termsofuse.rulesheader")}</h3>
                {t("termsofuse.rulestext")}
                <br />
                <br />
                <h3>{t("termsofuse.contractingpartiesheader")}</h3>
                {t("termsofuse.contractingpartiestext")}
                <br />
                <br />
                <h3>{t("termsofuse.personalinformationheader")}</h3>
                {t("termsofuse.personalinformationtext")}
                <br />
                <br />
                <h3>{t("termsofuse.registrationheader")}</h3>
                {t("termsofuse.registrationtext")}
                <br />
                <br />
                <h3>{t("termsofuse.userauthenticationheader")}</h3>
                {t("termsofuse.userauthenticationtext")}
                <br />
                <br />
                <h3>{t("termsofuse.servicesheader")}</h3>
                {t("termsofuse.servicestext")}
                <br />
                <br />
                <h3>{t("termsofuse.submittedmaterialheader")}</h3>
                {t("termsofuse.submittedmaterialtext")}
                <br />
                <br />
                <h3>{t("termsofuse.privacyheader")}</h3>
                {t("termsofuse.privacytext")}
                <br />
                <br />
                <h3>{t("termsofuse.cookiesheader")}</h3>
                {t("termsofuse.cookiestext")}
                <br />
                <br />
                <h3>{t("termsofuse.pricesheader")}</h3>
                {t("termsofuse.pricestext")}
                <br />
                <br />
                <h3>{t("termsofuse.usingservicesheader")}</h3>
                {t("termsofuse.usingservicestext")}
                <br />
                <br />
                <h3>{t("termsofuse.availabilityheader")}</h3>
                {t("termsofuse.availabilitytext")}
                <br />
                <br />
                <h3>{t("termsofuse.intellectualpropertyrightsheader")}</h3>
                {t("termsofuse.intellectualpropertyrightstext")}
                <br />
                <br />
                <h3>{t("termsofuse.validityandterminationheader")}</h3>
                {t("termsofuse.validityandterminationtext")}
                <br />
                <br />
                <h3>{t("termsofuse.responsibilitiesheader")}</h3>
                {t("termsofuse.responsibilitiestext")}
                <br />
                <br />
                <h3>{t("termsofuse.transferofcontractheader")}</h3>
                {t("termsofuse.transferofcontracttext")}
                <br />
                <br />
                <h3>{t("termsofuse.forcemajeureheader")}</h3>
                {t("termsofuse.forcemajeuretext")}
                <br />
                <br />
                <h3>{t("termsofuse.amendmentoftheagreementheader")}</h3>
                {t("termsofuse.amendmentoftheagreementtext")}
                <br />
                <br />
                <h3>{t("termsofuse.disputeresolutionandapplicablelawheader")}</h3>
                {t("termsofuse.disputeresolutionandapplicablelawtext")}
                <br />
                <br />
                <h3>{t("termsofuse.disclosuretoauthoritiesheader")}</h3>
                {t("termsofuse.disclosuretoauthoritiestext")}
                <br />
                <br />
                <h3>{t("termsofuse.validityoftermsofuseheader")}</h3>
                {t("termsofuse.validityoftermsofusetext")}
                <br />
                <br />
              </div>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Termsofuse;
